import { EffectsChain } from "../Nodes/EffectsChain.js";
import { SimpleEvent } from "../../HelperModules/SimpleEvent.js";
export class ConnectionManager {
    constructor(context) {
        this.effectsDeserialised = new SimpleEvent();
        this._context = context;
        this._outputGain = this._context.createGain();
        this._outputGain.connect(context.destination);
        this._bus = new EffectsChain(context);
        this._bus.chainName = "Bus";
        this._possibleConnections = { "Context": this._outputGain, "Bus": this._bus };
        this._possibleConnectionStrings = ["Context", "Bus"];
        this._currentConnections = {};
        this._chains = [];
        this.createConnections(this._bus, ["Context"]);
    }
    get possibleConnections() {
        return this._possibleConnections;
    }
    get possibleConnectionStrings() {
        return this._possibleConnectionStrings;
    }
    get outputGain() {
        return this._outputGain;
    }
    get bus() {
        return this._bus;
    }
    get chains() {
        return this._chains;
    }
    getConnections(object) {
        if (object.id in this._currentConnections) {
            return this._currentConnections[object.id];
        }
        else {
            throw new Error("Object not found");
        }
    }
    createConnections(object, connections) {
        if (object.id in this._currentConnections) {
            object.disconnectAll();
        }
        for (let i = 0; i < connections.length; i++) {
            if (connections[i] in this._possibleConnections) {
                object.connect(this._possibleConnections[connections[i]]);
            }
            else {
                throw new Error("Invalid connection name: " + connections[i]);
            }
        }
        this._currentConnections[object.id] = connections;
    }
    addConnection(object, connection) {
        if (connection in this._possibleConnections) {
            if (object.id in this._currentConnections) {
                if (this._currentConnections[object.id].indexOf(connection) == -1) {
                    this._currentConnections[object.id].push(connection);
                }
                else {
                    return;
                }
            }
            else {
                this._currentConnections[object.id] = [connection];
            }
            object.connect(this._possibleConnections[connection]);
        }
        else {
            throw new Error("Invalid connection name: " + connection);
        }
    }
    removeConnection(object, connection) {
        if (object.id in this._currentConnections) {
            let index = this._currentConnections[object.id].indexOf(connection);
            if (index != -1) {
                object.disconnect(this._possibleConnections[connection]);
                this._currentConnections[object.id].splice(index, 1);
            }
            else {
                throw new Error("Object does not have this connection");
            }
        }
        else {
            throw new Error("Object does not have any connections.");
        }
    }
    removeAllConnections(object) {
        object.disconnectAll();
        delete this._currentConnections[object.id];
    }
    addChain(settings) {
        let object = new EffectsChain(this._context, settings);
        if (settings === undefined) {
            let chainNo = 0;
            while (("Chain " + chainNo) in this._possibleConnections) {
                chainNo++;
            }
            ;
            let name = "Chain " + chainNo.toString();
            object.chainName = name;
            this.createConnections(object, EffectsChain.createDefaults().connections);
        }
        else {
            this.createConnections(object, settings.connections);
        }
        this._possibleConnectionStrings.push(object.chainName);
        this._possibleConnections[object.chainName] = object;
        this._chains.push(object);
        return object;
    }
    removeChain(name) {
        if (name.startsWith("Chain ") && name in this._possibleConnections) {
            let index = this._chains.indexOf(this._possibleConnections[name]);
            this._chains.splice(index, 1);
            delete this._possibleConnections[name];
            this._possibleConnectionStrings.splice(this._possibleConnectionStrings.indexOf(name), 1);
        }
        else {
            throw new Error("Object not in ConnectionManager");
        }
    }
    getChain(name) {
        if (name == "Bus") {
            return this._bus;
        }
        else {
            let chain = this._chains.find((value) => { value.chainName === name; });
            if (chain !== undefined) {
                return chain;
            }
            else {
                throw new Error("Invalid chain name");
            }
        }
    }
    getChainDelayTime(name) {
        let chain = this.getChain(name);
        let delayTime = chain.getDelayTime();
        if ("bus" in this._currentConnections[chain.id]) {
            delayTime += this._bus.getDelayTime();
        }
        return delayTime;
    }
    serialiseChains() {
        let serialisedChains = [];
        this.chains.concat(this.bus).forEach(chain => {
            let chainSettings = chain.serialise();
            if (chain.id in this._currentConnections) {
                chainSettings.connections = this._currentConnections[chain.id];
            }
            else {
                chainSettings.connections = ["Context"];
            }
            serialisedChains.push(chainSettings);
        });
        return serialisedChains;
    }
    deserialiseChains(newChains) {
        this._possibleConnectionStrings = ["Context"];
        this._possibleConnections = { "Context": this._outputGain };
        for (let i = 0; i < this._chains.length; i++) {
            delete this._possibleConnections[this._chains[i].chainName];
            this._possibleConnectionStrings.splice(this._possibleConnectionStrings.indexOf(this._chains[i].chainName), 1);
            this._chains[i].destroy();
        }
        this._chains = [];
        newChains.forEach(chain => {
            if (chain.chainName === "Bus") {
                this._bus = new EffectsChain(this._context, chain);
                this._possibleConnectionStrings.push("Bus");
                this._possibleConnections[chain.chainName] = this._bus;
                this.createConnections(this._bus, chain.connections);
            }
            else {
                this.addChain(chain);
            }
        });
        this.effectsDeserialised.emit();
    }
}
//# sourceMappingURL=ConnectionManager.js.map